import React from 'react'
import { useParams } from 'react-router-dom'
import loadComponent from 'src/utils/loadMFE'
import RouteContainer from 'src/components/App/RouteContainer'

const TrainingVideosDetails = React.lazy(() => loadComponent('traiwiss', 'TrainingVideosDetails'))

export function TrainingVideosDetailsRoute() {
    const params = useParams()

    return (
        <RouteContainer>
            <TrainingVideosDetails _id={params._id} />
        </RouteContainer>
    )
}
